export default __webpack_public_path__ + "static/media/delete.c3234f38.svg";